module.exports = __webpack_public_path__ + "img/testing_bussiness_ideas.e8a44e56.jpg";